import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { message, Skeleton } from 'antd';
import MainError from '../../errors/MainError';
import ContentHeader from '../../../components/ContentHeader';
import DictionaryForm from '../../../containers/shared/DictionaryForm';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import {
  useEditEducationInstitutionMutation,
  useGetEducationInstitutionQuery
} from '../../../store/apis/dictionaries/education-institution';

const Details = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [edit, { isLoading }] = useEditEducationInstitutionMutation();

  const {
    data: dictionaryData,
    isLoading: isDictionaryLoading,
    isFetching: isDictionaryFetching,
    error: dictionaryError,
  } = useGetEducationInstitutionQuery(id);

  const handleSubmit = useCallback(async (body) => {
    try {
      await edit({ id, body }).unwrap();
      message.success(t('Учреждение сохранено'));
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [edit, id, t]);

  const handleExit = useCallback(() => {
    navigate(routes.educationInstitution());
  }, [navigate]);

  if (isDictionaryLoading || isDictionaryFetching) return <Skeleton />
  if (dictionaryError) return <MainError error={dictionaryError} />

  return (
    <div>
      <ContentHeader title={dictionaryData.sysName} />
      <DictionaryForm
        onSubmit={handleSubmit}
        onExit={handleExit}
        initialValues={dictionaryData}
        loading={isLoading}
        saveTitle={t('Сохранить')}
        saveAndExitTitle={t('Сохранить и выйти')}
      />
    </div>
  );
};

export default Details;
